<template>
  <ez-form-modal ref="modal">
    <template #title>Assign to a Group</template>
    <template #content>
      <v-select-search
        name="clearingGroup"
        label="Clearing Group"
        placeholder="Choose Clearing Group"
        :hasClear="false"
        :data="clearingGroups"
        :selected="selectedGroup"
        @selected="onGroupChange"
        isFullWidth
      />
    </template>
    <template #footer>
      <ez-button type="link" @click="onCancel">Cancel</ez-button>
      <ez-button type="primary" @click="onSave" :disabled="!selectedGroup">
        Save Changes
      </ez-button>
    </template>
  </ez-form-modal>
</template>

<script>
import { mapActions } from 'vuex';
import EzFormModal from '@/components/ui/Modal/EzFormModal.vue';
import EzButton from '@/components/ui/Button/EzButton.vue';
import VSelectSearch from '@/components/v3/patterns/VSelectSearch';

export default {
  name: 'AssignClearingGroupModal',
  components: {
    EzFormModal,
    EzButton,
    VSelectSearch,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedGroup: null,
      clearingGroups: [],
    };
  },
  methods: {
    ...mapActions('entities/groups', ['adminFetchClearingGroups']),
    async open() {
      this.selectedGroup = this.invoice?.clearingGroup ?? null;
      await this.fetchClearingGroups();
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    onCancel() {
      this.selectedGroup = null;
      this.close();
      this.$emit('cancel');
    },
    onSave() {
      this.close();
      this.$emit('save', this.selectedGroup?.id ?? null);
    },
    onGroupChange(group) {
      this.selectedGroup = group;
    },
    async fetchClearingGroups() {
      const { data } = await this.adminFetchClearingGroups();
      this.clearingGroups = data.data;
    },
  },
};
</script>

<style lang="scss" scoped></style>
